import React from 'react'

export default ({ width = 100, height = 100, fill = "#dcf4fa" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
      <g id="temperature_icon" transform="translate(-829 -387)">
        <g id="noun_Temperature_7810" transform="translate(852.848 388)">
          <g id="Group_1089" data-name="Group 1089" transform="translate(1.152)">
            <g id="Group_1088" data-name="Group 1088">
              <path id="Path_3222" data-name="Path 3222" d="M24.514,40.239l8.774-5.477-8.774-5.477ZM64.553,67.517V34.761H49.5V67.648a15.755,15.755,0,1,0,15.057-.131Z" transform="translate(-24.514 -0.662)" fill={fill} />
              <path id="Path_3223" data-name="Path 3223" d="M66.411,65.9V8.985a8.982,8.982,0,1,0-17.964,0V65.9a17.189,17.189,0,1,0,17.964,0ZM57.429,95.156A14.6,14.6,0,0,1,49.8,68.107l1.232-.757V8.985a6.4,6.4,0,1,1,12.794,0V67.35l1.232.754a14.6,14.6,0,0,1-7.63,27.053ZM44.971,7.693H37.05v2.585h7.921Zm0,15.14V20.248H39.593v2.585Zm0,35.085H37.05V60.5h7.921Zm0-25.111H37.05v2.585h7.921Zm0,15.14V45.362H39.593v2.584Z" transform="translate(-24.797)" fill={fill} />
              <line id="Line_172" data-name="Line 172" y2="56.918" transform="translate(23.65 8.985)" fill={fill} />
            </g>
          </g>
        </g>
        <g id="Rectangle_1829" data-name="Rectangle 1829" transform="translate(829 387)" fill="none" stroke="#707070" strokeWidth="1" opacity="0">
          <rect width="100" height="100" stroke="none"/>
          <rect x="0.5" y="0.5" width="99" height="99" fill="none"/>
        </g>
      </g>
    </svg>
  )
}
